App.controller('ProfileNewCtrl', ['$rootScope','$scope', '$state', '$localStorage', '$loading', 'toastr',
    '$timeout', 'ngDialog', '$window', '$http', '$sessionStorage', 'Api', 'authApi','Idle','idleModelService', 'ProfessionalService', 'sessionService', 'UserConstants', 'BriefcaseNavigation',

    function ($rootScope,$scope, $state, $localStorage, $loading, toastr, $timeout, ngDialog, $window, $http, $sessionStorage, Api, authApi, Idle, idleModelService, ProfessionalService, sessionService, UserConstants, BriefcaseNavigation) {

        var token = $localStorage['token'];
        if (token) {
            // allowed to access this controller


            var viewModel = this;
            viewModel.init = init;
            viewModel.hideJobCheckLists = true;
            viewModel.hideProfileCheckList = true;
            viewModel.goToJobs = goToJobs;
            viewModel.markProfileItem = markProfileItem;
            viewModel.coBrandedKEY = $sessionStorage.coBrandedKEY;
            //viewModel.toggleChecklist = toggleChecklist;
            viewModel.goToEducation = goToEducation;
            viewModel.goToProfile = goToProfile;
            viewModel.openPrnJobPopup = openPrnJobPopup;
            viewModel.closePopup = closePopup;
            viewModel.user = {};
            viewModel.determinateValue = 0;
            viewModel.determinateValueNew = 0;
            viewModel.showJobCheckList = false;
            viewModel.isPRN = 0;
            viewModel.showJobChecklist = showJobChecklist;
            viewModel.hideJobChecklist = hideJobChecklist;
            viewModel.professionalBriefcaseKeys = [];
            viewModel.jobKeys = [];
            viewModel.stroke = 10;
            viewModel.bgColor = '#f4f0f3';
            viewModel.openDropdown = openDropdown;
            viewModel.open = false;
            viewModel.checkHoverEnter = checkHoverEnter;
            viewModel.checkHoverLeave = checkHoverLeave;
            viewModel.checkJobAvailability = checkJobAvailability;
            viewModel.openBriefcase = openBriefcase;
            viewModel.profileCheckList = angular.copy(UserConstants.profileCheckList);
            viewModel.jobCheckList = [{
                    id: 'professionalBriefcase',
                    text: 'Professional Briefcase',
                    checked: false
                },
                {
                    id: 'fullSSN',
                    text: 'Full SSN',
                    checked: false
                },
                {
                    id: 'skillschecklist',
                    text: 'Skills Checklist',
                    checked: false
                },
                {
                    id: 'w9',
                    text: 'W9',
                    checked: false
                },
                {
                    id: 'PaymentInformation',
                    text: 'Payment Information',
                    checked: false
                },
                {
                    id: 'driversLicense',
                    text: 'Drivers License',
                    checked: false
                },
                {
                    id: 'healthScreen',
                    text: 'Health Screens',
                    checked: false
                }
            ];

            viewModel.init();

            this.updateData = function (data){
                if(data){
                    const {firstName, briefcase = {}, affiliations, isMarketplace} = data;
                    const summary = _.get(data, 'briefcase.summary', {});
                    viewModel.isLicensed = !!_.get(data, 'briefcase.licensedAt');
                    const { count, checkCount } = viewModel.profileCheckList.reduce((acc,item) => {
                        ++acc.count;
                        if(item.id.some((i) => !!summary[i])){
                            item.checked = true;
                            ++acc.checkCount;
                        }
                        return acc;
                    }, { count: 0, checkCount: 1 });
                    viewModel.determinateValueNew = count > 1 ? Math.round(100 / count * checkCount) : 0;
                    viewModel.user = { firstName, currentStep: briefcase.currentStep };
                    viewModel.hideJobCheckLists = true;
                    viewModel.hideProfileCheckList = true;
                    viewModel.isApproved = !!briefcase && !!briefcase.completedAt;
                    viewModel.bannerImage = (affiliations || []).length === 1 ?
                        _.get(affiliations, '[0].organization.facility.bannerURL', 'img/bitmap@3x.jpg') : 'img/bitmap@3x.jpg';
                    viewModel.logoImage = (affiliations || []).length === 1 ?
                        _.get(affiliations, '[0].organization.facility.logoURL', '/img/logo.png') : '/img/logo.png';
                    $localStorage.logoImage = viewModel.logoImage;
                    $localStorage.bannerImage = viewModel.bannerImage;
                    $localStorage.affiliations = affiliations;
                    $timeout(() => $loading.finish('splash'), 500);
                }
            }

            this.$onInit = function (){
                $scope.subscription = sessionService.professionalData.subscribe(this.updateData.bind(this));
                $scope.$on('$destroy', $scope.subscription);
            }

            $scope.$on('$viewContentLoaded', function () {
                $timeout(function () {
                    $loading.start('splash');
                    if ($('#rightdiv') && $('#leftdiv')) {
                        var right = $('#rightdiv').outerHeight();
                        var left = $('#leftdiv').outerHeight();
                        if (left > 157) {
                            $('#rightdiv').outerHeight(left);
                        }
                    }
                });
            });

            if ($(window)) {
                $(window).resize(function () {
                    if ($('#rightdiv') && $('#leftdiv')) {
                        var right = $('#rightdiv').outerHeight();
                        var left = $('#leftdiv').outerHeight();
                        if (left > 157) {
                            $('#rightdiv').outerHeight(left);
                        }
                    }
                });
            }

            // =============init function=============
            function init() {
                if($state.includes("education")){
                   // console.log('loading started')
                    $window.scrollTo(0, 0);
                    $loading.start('splash');
                    $timeout(function(){
                        $loading.finish('splash');
                    }, 2000)
                }

            }

            // =======================================
            // =======================================
            // check if a user lands in jobs of has to complete profile
            // =======================================
            // =======================================
            function checkJobAvailability() {
                if(!(viewModel.user.currentStep >= 2)) {
                    viewModel.openPrnJobPopup();
                } else {
                    viewModel.goToJobs();
                }
            }

            // =============to show job checklist=============
            function showJobChecklist() {
                viewModel.showJobCheckList = true;
            }

            // =============to hide job checklist=============
            function hideJobChecklist() {
                if (!viewModel.hideProfileCheckList) {
                    viewModel.showJobCheckList = false;
                    viewModel.init();
                }
            }

            // =============to go to education page=============
            function goToEducation() {
                $loading.start('splash');
                $state.go('education');
            }

            // =============to go to profile page=============
            function goToProfile() {
                $loading.start('splash');
                $state.go('dashboard.profile');
            }

            // =============to update the progress bar=============
            function markProfileItem(item) {
                item.checked = true;
                viewModel.determinateValue = 0;
                viewModel.profileCheckList.map(updateProgressBar);
            }

            // =============to go to jobs page=============
            function goToJobs() {
                $loading.start('splash');
                $state.go('dashboard.jobs');
            }

            // ===========to show profile completion popup==========
            function openPrnJobPopup() {
                dialogId = ngDialog.open({
                    template: 'prnJobInfoPopupOp',
                    className: 'ngdialog-theme-default documentation-dialog prn-dialog incompleteDashboard',
                    closeByNavigation: true,
                    showClose: false,
                    scope: $scope,
                    closeByDocument: false,
                    closeByEscape: false
                });
            }



            // =============to close popup=============
            function closePopup() {
                ngDialog.closeAll();
                $loading.start('splash');
                $state.go('dashboard.profile');
            }

        } else {
            window.location.hash = '/login';
            window.location.reload();
        }

        function openDropdown() {
            viewModel.open = !viewModel.open
            // if (viewModel.open) {
            //     viewModel.bgColor = 'white'
            // } else {
            //     viewModel.bgColor = '#f4f0f3'
            // }
        }

        function openBriefcase(route) {
            $state.go(BriefcaseNavigation.navigate(route.minStep, viewModel.user.currentStep));
        }

        function checkHoverEnter() {
            // if (!viewModel.open) {
            //     viewModel.bgColor = 'white'
            // }
        }

        function checkHoverLeave() {
            if (!viewModel.open) {
                viewModel.bgColor = '#f4f0f3'
            }

        }
    }
]);
